import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-plugins',
	templateUrl:'./PluginsPage.html',
	styles: [],
	styleUrls:['./PluginsPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		WaTagDirective,
		WaCardDirective,
		RouterModule,
		WaButtonDirective,
],
	standalone:true
})
export class PluginsPage
{
	mdContent_8 = `Every JWebMP plugin is a proper JPMS module with an explicit \`module-info.java\`. Add the Maven dependency, and the component is immediately available as a type-safe Java class. The Angular Maven Plugin generates all the TypeScript integration at build time. No \`npm install\`. No Angular module registration. Just Java.`;
}
